import script from "./manage-member.vue?vue&type=script&lang=ts&setup=true"
export * from "./manage-member.vue?vue&type=script&lang=ts&setup=true"

import "./manage-member.vue?vue&type=style&index=0&id=6d24421a&lang=scss&scoped=true"

import exportComponent from "../../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['__scopeId',"data-v-6d24421a"]])

export default __exports__